import React from 'react';
type Variant = 'primary' | 'secondary';
type Size = 'sm' | 'md';
interface PathwayButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}

/**
 * Button styling for the Pathway Builder tool only, matching the Figma
 * component set: pill buttons at 28px radius, red fill for primary and a
 * light hairline border for secondary.
 */
const base = 'inline-flex items-center justify-center gap-2 rounded-[28px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-40';
const sizes: Record<Size, string> = {
  md: 'h-10 px-6 text-base min-w-[160px]',
  sm: 'h-9 px-5 text-sm min-w-[112px]'
};
const variants: Record<Variant, string> = {
  primary: 'bg-[#DB3725] text-white hover:bg-[#c02f1f]',
  secondary: 'border-2 border-[#F2F3F3] bg-white text-[#3A4F59] hover:border-gray-300 hover:bg-gray-50'
};
export function PathwayButton({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  type = 'button',
  children,
  ...rest
}: PathwayButtonProps) {
  return <button type={type} className={`${base} ${sizes[size]} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...rest} data-id="element-1598" data-mp="xmym90su8gxw">
      {children}
    </button>;
}